<ng-template #addCrmModal>

<div class="crm-modal-container">
  <div class="crm-modal-header">{{ (editMode ? 'CRM.ADD_CRM_MODAL.EDIT_SONAR_RECORD' : 'CRM.ADD_CRM_MODAL.NEW_SONAR_RECORD') | translate }}</div>
  <div *ngIf="newRecordWarning" class="new-record-warning d-flex mt-4 py-3 pl-3 pr-1">
    <img src="/assets/icons/exclamation-circle.svg" alt="Exclamation Circle" class="mr-2" />
    {{ "CRM.ADD_CRM_MODAL.POST_NOTE_WARNING" | translate }}
  </div>

  <div class="modal-body w-100">
    <div class="crm-item-type-selector-container">
      <label for="crmItemType">Sonar Record Type</label>
      <ng-select id="crmItemType" [(ngModel)]="crmItemType" [searchable]="false" [clearable]="false" [disabled]="!!inputCrmItem">
        <ng-option [value]="itemTypes.STANDARD">Standard</ng-option>
        <ng-option [value]="itemTypes.STRUCT_CAP">Structured Capital</ng-option>
      </ng-select>
    </div>

    <ng-container [ngSwitch]="crmItemType">
      <rms-crm-standard-form *ngSwitchCase="itemTypes.STANDARD" #standardForm
                             [inputCrmItem]="inputCrmItem"
                             [inputCompanyId]="inputCompanyId"
                             [editMode]="editMode"
                             [companyList]="companyList"
                             (formSubmitted)="submit($event)">
        <div class="modal-footer justify-content-between flex-row-reverse">
          <div>
            <div class="btn btn-default" (click)="close()">{{"GENERICS.CANCEL" | translate}}</div>
            <div class="btn btn-primary" (click)="standardForm.submit()" [ngClass]="{'disabled': standardForm.cannotSubmit()}">{{"GENERICS.SAVE" | translate}}</div>
          </div>
          <div *ngIf="editMode">
            <div class="btn archive-button" (click)="archiveRecord(inputCrmItem)">{{ "CRM.ARCHIVE_MODAL.ARCHIVE" | translate }}</div>
          </div>
        </div>
      </rms-crm-standard-form>
      <rms-crm-struct-cap-form *ngSwitchCase="itemTypes.STRUCT_CAP" #structCapForm
                               [inputCrmItem]="inputCrmItem"
                               [inputCompanyId]="inputCompanyId"
                               [editMode]="editMode"
                               [companyList]="companyList"
                               (formSubmitted)="submit($event)">
        <div class="modal-footer">
          <div class="checkbox" *ngIf="!editMode">
            <input id="should-notify" name="shouldNotify" type="checkbox" class="checkbox" [(ngModel)]="shouldNotify" />
            <label for="should-notify" class="notify-label">Send email on Save</label>
          </div>
          <div class="btn btn-default" (click)="close()">{{"GENERICS.CANCEL" | translate}}</div>
          <div class="btn btn-primary" (click)="structCapForm.submit()" [ngClass]="{'disabled': structCapForm.cannotSubmit()}">{{"GENERICS.SAVE" | translate}}</div>
        </div>
      </rms-crm-struct-cap-form>
    </ng-container>
  </div>
</div>
</ng-template>
